import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6641fd36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 mx-auto textcenter" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, " FCA views on those who cannot access benefits yet ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The Financial Conduct Authority (FCA) view is that anyone "),
  /*#__PURE__*/_createElementVNode("strong", null, "who cannot access"),
  /*#__PURE__*/_createTextVNode(" their benefits in the near future should remain in the scheme and seek a revised transfer value, if they still wish to consider one, nearer the time that they can. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-4" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "What to do next?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you still wish to seek advice on a potential transfer")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please contact Origen Financial Services so we can understand your situation and see if we can help. Our advice is based on your own personal circumstances, and financial objectives to help you maximise your retirement income. ", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.fca.org.uk/scamsmart",
  target: "_blank"
}, "FCA's scamsmart website", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/watch?v=TYk_X3tn9hc",
  target: "_blank"
}, "watch this video on avoiding scams", -1))
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-6641fd36><div class=\"col-md-2\" data-v-6641fd36><p data-v-6641fd36>Call:</p></div><div class=\"col-md-10 fw-bold\" data-v-6641fd36><p data-v-6641fd36>0800 068 8214 </p></div></div><div class=\"row\" data-v-6641fd36><div class=\"col-md-2\" data-v-6641fd36><p data-v-6641fd36>Email:</p></div><div class=\"col-md-10\" data-v-6641fd36><a href=\"mailto:guiide@origenfs.co.uk\" data-v-6641fd36>guiide@origenfs.co.uk</a></div></div>", 2)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Website:")
], -1))
const _hoisted_17 = { class: "col-md-10" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\" data-v-6641fd36><div class=\"col\" data-v-6641fd36><p data-v-6641fd36> Call us for an initial meeting and let us help you plan a brighter financial future. All calls are recorded for business purposes. </p></div></div><div class=\"row\" data-v-6641fd36><div class=\"col\" data-v-6641fd36><img src=\"/Content/images/origen/origen-award-strip.png\" class=\"img-fluid mb-3\" alt=\"Origen Global Awards\" data-v-6641fd36></div></div>", 2)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " To be clear any adviser shown will not provide advice on a defined benefit transfer, only general retirement planning advice. ", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, " FCA views on those who are not ready to access their benefits yet ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The Financial Conduct Authority (FCA) view is that anyone "),
  /*#__PURE__*/_createElementVNode("strong", null, "who does not wish to access"),
  /*#__PURE__*/_createTextVNode(" their benefits in the near future should remain in the scheme and seek a revised transfer value, if they still wish to consider one, nearer the time that they wish to access benefits. ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-4" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "What to do next?", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you still wish to seek advice on a potential transfer")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please contact Origen Financial Services so we can understand your situation and see if we can help. Our advice is based on your own personal circumstances, and financial objectives to help you maximise your retirement income. ", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.fca.org.uk/scamsmart",
  target: "_blank"
}, "FCA's scamsmart website", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/watch?v=TYk_X3tn9hc",
  target: "_blank"
}, "watch this video on avoiding scams", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you require help with future retirement planning")
], -1))
const _hoisted_36 = ["href"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " You will need to seek specialist advice from an adviser who deals in the UK and the country you are moving to, or separate UK and Overseas advisers. ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We will shortly be adding an adviser who can provide this joint advice to most popular overseas destinations. ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you wish to still seek advice on a transfer at this time you can visit "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.unbiased.co.uk",
    target: "_blank"
  }, "unbiased.com"),
  /*#__PURE__*/_createTextVNode(" to find a suitable adviser or advisers, or visit "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.pensionwise.gov.uk/en",
    target: "_blank"
  }, "Pensionwise"),
  /*#__PURE__*/_createTextVNode(" or the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.moneyadviceservice.org.uk/en",
    target: "_blank"
  }, "Money Advice Service"),
  /*#__PURE__*/_createTextVNode(" for further guidance. ")
], -1))
const _hoisted_43 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { key: 3 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, " Transfer Values Below Thirty Thousand Pounds ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " There is no regulatory requirement to take advice on a transfer below £30K. Origen can provide advice on this but it would be subject to a minimum fee. Please contact us using our details below to see how we can help. ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, " Transferring without advice ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If you wish to transfer without taking advice, after considering this yourself, you can do so. However, you may find it very difficult to find a provider who will accept a transfer value where advice has not been taken (even if this is not a legal requirement) as very few providers do. If you have a workplace defined contribution pension scheme that you are paying into, check with them first to see if they will accept it. ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, " What to do next ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you still wish to seek advice on a potential transfer")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please contact Origen Financial Services so we can understand your situation and see if we can help. Our advice is based on your own personal circumstances, and financial objectives to help you maximise your retirement income. ", -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.fca.org.uk/scamsmart",
  target: "_blank"
}, "FCA's scamsmart website", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/watch?v=TYk_X3tn9hc",
  target: "_blank"
}, "watch this video on avoiding scams", -1))
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-6641fd36><div class=\"col-md-2\" data-v-6641fd36><p data-v-6641fd36>Call:</p></div><div class=\"col-md-10 fw-bold\" data-v-6641fd36><p data-v-6641fd36>0800 068 8214 </p></div></div><div class=\"row\" data-v-6641fd36><div class=\"col-md-2\" data-v-6641fd36><p data-v-6641fd36>Email:</p></div><div class=\"col-md-10\" data-v-6641fd36><a href=\"mailto:guiide@origenfs.co.uk\" data-v-6641fd36>guiide@origenfs.co.uk</a></div></div>", 2)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Website:")
], -1))
const _hoisted_59 = { class: "col-md-10" }
const _hoisted_60 = ["href"]
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\" data-v-6641fd36><div class=\"col\" data-v-6641fd36><p data-v-6641fd36> Call us for an initial meeting and let us help you plan a brighter financial future. All calls are recorded for business purposes. </p></div></div><div class=\"row\" data-v-6641fd36><div class=\"col\" data-v-6641fd36><img src=\"/Content/images/origen/origen-award-strip.png\" class=\"img-fluid mb-3\" alt=\"Origen Global Awards\" data-v-6641fd36></div></div>", 2)
const _hoisted_63 = {
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, " This button will not be available on the member site, the journey will end here. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.TerminationType == _ctx.TerminusType.YoungAndInGoodHealth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createTextVNode(" If you choose this route, please visit the "),
                    _hoisted_11,
                    _createTextVNode(" to ensure you understand how potential scams may occur. Alternatively "),
                    _hoisted_12,
                    _createTextVNode(" from our friends at Quietroom. ")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_13,
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    href: 'https://' + _ctx.advisor,
                    target: "_blank"
                  }, _toDisplayString(_ctx.advisor), 9, _hoisted_18)
                ])
              ]),
              _hoisted_19,
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, " These tools may provide everything you need, but if you need advice on future retirement planning it will also signpost you to our general retirement adviser panel if you wish to seek this. "))
                : _createCommentVNode("", true),
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _hoisted_24))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.TerminationType == _ctx.TerminusType.NotGoingToTakePensionSoon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _createTextVNode(" If you choose this route, please visit the "),
                    _hoisted_33,
                    _createTextVNode(" to ensure you understand how potential scams may occur. Alternatively "),
                    _hoisted_34,
                    _createTextVNode(" from our friends at Quietroom. ")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_35,
              _createElementVNode("p", null, [
                _createTextVNode(" If you want further guidance and planning tools, to help you see how to use your current scheme benefits (and anything else you have) for retirement planning, you can use our retirement planning site "),
                _createElementVNode("a", {
                  href: 'https://' + _ctx.advisor,
                  target: "_blank"
                }, _toDisplayString(_ctx.advisor), 9, _hoisted_36),
                _createTextVNode(" at no cost. ")
              ]),
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_37, " These tools may provide everything you need, but if you need advice on future retirement planning it will also signpost you to our general retirement adviser panel if you wish to seek this. "))
                : _createCommentVNode("", true),
              (_ctx.isGuiide)
                ? (_openBlock(), _createElementBlock("p", _hoisted_38, " To be clear any adviser shown will not provide advice on a defined benefit transfer, only general retirement planning advice. "))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.TerminationType == _ctx.TerminusType.PlanningToLeaveUK)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_43))
            : (_ctx.TerminationType == _ctx.TerminusType.TransferValueTooLow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _hoisted_46,
                  _hoisted_47,
                  _hoisted_48,
                  _hoisted_49,
                  _hoisted_50,
                  _hoisted_51,
                  (_ctx.isGuiide)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                        _createTextVNode(" If you choose this route, please visit the "),
                        _hoisted_53,
                        _createTextVNode(" to ensure you understand how potential scams may occur. Alternatively "),
                        _hoisted_54,
                        _createTextVNode(" from our friends at Quietroom. ")
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("a", {
                        href: 'https://' + _ctx.advisor,
                        target: "_blank"
                      }, _toDisplayString(_ctx.advisor), 9, _hoisted_60)
                    ])
                  ]),
                  _hoisted_61
                ]))
              : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("input", {
            type: "button",
            value: "Go Back to Start",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBackToStart && _ctx.goBackToStart(...args)))
          })
        ], 512), [
          [_vShow, false]
        ])
      ])
    ])
  ]))
}